// extracted by mini-css-extract-plugin
module.exports = {"root":"dot-navigation_root__F-f9z","dotActive":"dot-navigation_dotActive__DNbp2","dotInactive":"dot-navigation_dotInactive__GHEMH"};